import styled from '@emotion/styled'
import { mdiFilterVariant } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import shape from '../styles/shape'

interface IFilter {
    size?: number
}

const StyledIcon = styled(Icon)({
    borderRadius: shape.borderRadius,
})

const Filter = (props: IFilter) => {
    const { size = 1 } = props

    return (
        <StyledIcon
            data-testid="IconButton__Filter"
            path={mdiFilterVariant}
            size={size}
        />
    )
}

export default memo(Filter)
